import { useState } from "react"

import { ChevronDownIcon, ChevronUpIcon } from "./icons"
import { CursorGrid } from "../services/CursorGrid"

interface Props {
  axis: "X" | "Y"
  value: number
  onChange: (value: number) => void
}

export const CoordinateInput = ({ axis, value, onChange }: Props) => {
  // What the visitor is typing; only whole numbers reach the hotspot, the rest waits for blur.
  const [draft, setDraft] = useState<string | null>(null)

  return (
    <div className="input h-12.5 w-full gap-2 overflow-hidden pr-0">
      <span className="text-xs font-extrabold text-muted-content" aria-hidden="true">
        {axis}
      </span>
      <input
        type="number"
        name={`hotspot_${axis.toLowerCase()}`}
        min={0}
        max={CursorGrid.SIZE - 1}
        step={1}
        inputMode="numeric"
        aria-label={`Hotspot ${axis}`}
        value={draft ?? value}
        onChange={(event) => {
          const text = event.currentTarget.value
          setDraft(text)
          if (/^-?\d+$/.test(text)) onChange(CursorGrid.clamp(Number(text)))
        }}
        onBlur={() => setDraft(null)}
        onKeyDown={(event) => {
          if (event.key === "Enter") event.currentTarget.blur()
        }}
        className="min-w-0 flex-1 [appearance:textfield] font-extrabold [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:appearance-none"
      />
      <span className="flex flex-col self-stretch border-l border-base-content/10">
        <button
          type="button"
          aria-label={`Increase ${axis}`}
          onClick={() => onChange(CursorGrid.clamp(value + 1))}
          className="grid h-6 w-6 cursor-pointer place-items-center bg-neutral text-muted-content hover:bg-primary/15 hover:text-primary"
        >
          <ChevronUpIcon className="size-3" />
        </button>
        <button
          type="button"
          aria-label={`Decrease ${axis}`}
          onClick={() => onChange(CursorGrid.clamp(value - 1))}
          className="grid h-6 w-6 cursor-pointer place-items-center border-t border-base-content/10 bg-neutral text-muted-content hover:bg-primary/15 hover:text-primary"
        >
          <ChevronDownIcon className="size-3" />
        </button>
      </span>
    </div>
  )
}
